<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-bold`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M26.5 6a9.5 9.5 0 016.193 16.704A10.002 10.002 0 0139 32c0 5.523-4.477 10-10 10H13a2 2 0 01-2-2V8a2 2 0 012-2h13.5zm1.761 19.523H16V37h12.261a5.739 5.739 0 00.22-11.473l-.22-.004zM26.236 11H16v9.529h10.236a4.764 4.764 0 000-9.529z"/></svg>
</template>
<script>

export default {
  name: 'IconBold',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
